import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { Card, Divider, Grid, Typography } from "@mui/material";
import moment from "moment/moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  addDirectBilling,
  getAllClinicPaymentOfHugeRecord,
  getBillingDashboardData,
  getClinicUsers,
  getRecentTransactionsPayment,
  updateMultiplePayment,
} from "../../../redux/reducers/clinicSlice";
import { deletePaymentById } from "../../../redux/reducers/paymentSlice";
import { getClinicPetList } from "../../../redux/reducers/petSlice";
import { AppColors } from "../../../util/AppColors";
import {
  delBtn,
  w10h10GrayIcon,
  w20h20BlueIcon,
} from "../../../util/CommonIconStyle";
import { billAsForBillingHistory } from "../../../util/dropList";
import { paymentStatusEnum } from "../../../util/enum";
import {
  getPaymentStatus,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  roundWithSignedDiff,
} from "../../../util/function";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import PaymentReturn from "../../CommonScreens/Payments/PaymentReturn";

const initValues = { customer: null, searchValue: "", invoiceNumber: [] };
const initSaleValues = {
  billAs: "Pharmacy",
  searchType: "user",
  visible: false,
  searchEnabled: false,
  user: null,
  pet: null,
};

const PaymentDashboard = ({
  setActiveTab,
  setPosModVsble,
  setSelecetdPayment,
  setPaymentId,
  setPaymentTableType,
  setSelectedPaymentTab,
}) => {
  const dispatch = useDispatch();
  const [delModVsble, setDelModVsble] = useState(false);
  const [collectPayModVsble, setCollectPayModVsble] = useState(false);
  const [newSaleValues, setNewSaleValues] = useState(initSaleValues);
  const [modValues, setModValues] = useState(initValues);
  const [modErrors, setModErrors] = useState({});
  const [posSelectedPayment, setPosSelectedPayment] = useState(null);
  const [retModVsble, setRetModVsble] = useState(false);
  const {
    billDashboardData,
    users,
    hugePayments,
    details: clinicData,
  } = useSelector((state) => state?.clinic);
  const { clinicPets: pets, clinicPetList } = useSelector(
    (state) => state?.pet,
  );
  const dashData = billDashboardData?.data ?? {};
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { dataSharing: branchesDataSharing, clinic: clinicDetails } =
    useMemo(() => {
      if (!mandateDataRaw) {
        return { dataSharing: {}, clinic: {} };
      }
      try {
        const reqData = JSON.parse(mandateDataRaw);
        return {
          dataSharing: reqData?.dataSharing ?? {},
          clinic: reqData?.clinic ?? {},
        };
      } catch {
        return { dataSharing: {}, clinic: {} };
      }
    }, [mandateDataRaw]);
  const clinicDet = clinicDetails?.id ? clinicDetails : clinicData;
  const isBillCombined =
    (clinicDet?.billingMode ?? "")?.toLowerCase() === "combined";

  useEffect(() => {
    onApiCall();
  }, []);

  useEffect(() => {
    if (modValues?.searchValue?.length > 2) {
      dispatch(
        getClinicUsers(`?search=${modValues?.searchValue}&itemSize=50&page=1`),
      );
    }
  }, [modValues?.searchValue]);

  const onApiCall = () => {
    dispatch(getBillingDashboardData());
  };

  const onViewAllTrans = (typ = null) => {
    setSelectedPaymentTab(
      typ === "unpaid"
        ? "Finalized"
        : typ === "all"
          ? "Finalized"
          : "Collections",
    );
    setPaymentTableType(typ);
    setActiveTab("Payments");
  };

  const onNewSale = () => {
    setNewSaleValues({ ...newSaleValues, visible: true });
    // setPaymentId(null);
    // setPosModVsble(true);
    // setActiveTab("PointOfSales");
  };

  const onCloseNewSaleMod = () => {
    setNewSaleValues(initSaleValues);
  };

  const onEditPos = (itm) => {
    setPaymentId(itm?.paymentId ?? null);
    setSelecetdPayment(itm ?? null);
    setPosModVsble(true);
    setActiveTab("PointOfSales");
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelecetdPayment(null);
  };

  const onConfirmDelete = () => {
    if (!posSelectedPayment?.paymentId) return;
    dispatch(deletePaymentById(posSelectedPayment?.paymentId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        onApiCall();
        dispatch(getRecentTransactionsPayment("?filter=all&type=resent"));
      }
    });
  };

  const onDeletePos = (itm) => {
    setPosSelectedPayment(itm);
    setDelModVsble(true);
  };

  const onReturn = () => {
    setRetModVsble(true);
  };

  const onCloseReturn = (typ = null) => {
    if (typ === "apiSuccess") {
      setActiveTab("Returns");
    }
    setRetModVsble(false);
  };

  const getPaidPercentage = () => {
    let percentageChange = 0;
    const yesTotal = dashData?.yesterdayPaidTotalAmount ?? 0;
    const todayTotal = dashData?.paidTotalAmount ?? 0;
    if (Number(yesTotal) === 0) {
      percentageChange = Number(todayTotal ?? 0) === 0 ? 0 : 100;
    } else {
      percentageChange =
        Number(
          Number(Number(todayTotal ?? 0) - Number(yesTotal ?? 0)) /
            Number(yesTotal ?? 0),
        ) * 100;
    }
    return Math.floor(percentageChange ?? 0);
  };

  const onCloseCollectPay = () => {
    setCollectPayModVsble(false);
    setModValues(initValues);
  };

  const onCollectPay = () => {
    setCollectPayModVsble(true);
  };

  const onChangeModValue = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...modValues, [name]: value };
    const errs = {
      ...modErrors,
      [name]:
        (typeof reqValue === "number" ? reqValue?.toString() : reqValue)
          ?.length > 0
          ? ""
          : "This field is required",
    };
    if (name === "invoiceNumber") {
      const reqList =
        modValues?.invoiceNumber?.some((li) => li?.value === "All") &&
        !value?.some((li) => li?.value === "All")
          ? []
          : value?.some((li) => li?.value === "All")
            ? getInvoiceList()
            : value;
      reqObj.invoiceNumber = reqList;
      reqObj.amount = Number(
        reqList?.reduce((acc, obj) => {
          return acc + (Number(obj?.total ?? 0) ?? 0);
        }, 0),
      );
      errs.invoiceNumber =
        (value ?? [])?.length > 0 ? "" : "This field is required";
    }
    if (name === "amount") {
      if (modValues?.paymentMode?.value === "advanceAdjustment") {
        errs.amount =
          Number(value) < 0
            ? "Amount must be positive"
            : Number(value) > Number(getInvoiceList()?.[0]?.advanceAmount ?? 0)
              ? "Insufficient credit balance"
              : "";
      } else {
        errs.amount = Number(value) < 0 ? "Amount must be positive" : "";
      }
      if (
        Number(value) >
        modValues?.invoiceNumber?.reduce((acc, obj) => {
          return acc + (Number(obj?.total ?? 0) ?? 0);
        }, 0)
      ) {
        errs.amount = "Amount must be less than or equal to balance due";
      }
    }
    setModErrors(errs);
    setModValues(reqObj);
  };

  const getFilteredUserList = () => {
    const reqList = users?.filter((usr) => {
      if (
        usr?.name
          ?.toLowerCase()
          .includes(modValues?.searchValue?.toLowerCase()) ||
        usr?.email
          ?.toLowerCase()
          .includes(modValues?.searchValue?.toLowerCase()) ||
        usr?.mobile
          ?.toLowerCase()
          .includes(modValues?.searchValue?.toLowerCase())
      ) {
        return usr;
      }
    });
    return reqList ?? [];
  };

  const handleSelectedUser = (user) => {
    const modObj = {
      ...modValues,
      customer: { name: user?.name, value: user?.id },
      searchValue: "",
    };
    setModErrors({ ...modErrors, customer: "" });
    dispatch(
      getAllClinicPaymentOfHugeRecord(
        `?filter=all&type=all&page=1&itemSize=30&userId=${user?.id}`,
      ),
    );
    setModValues(modObj);
  };

  const getInvoiceList = () => {
    const reqList = (hugePayments?.data ?? [])?.map((li) => {
      const total = roundWithSignedDiff(
        Number(
          getTaxAndSubTotalAndTotal(
            getTreatmentRecordBasedType(li?.paymentDetails),
          )?.total +
            getTaxAndSubTotalAndTotal(
              getPharmacyRecordBasedType(li?.paymentDetails),
            )?.total +
            getTaxAndSubTotalAndTotal(
              getPetShopRecordBasedType(li?.paymentDetails),
            )?.total,
        ) - Number(li?.amtPaid ?? 0),
      )?.rounded;
      const invoiceNumbers = [
        li?.invoiceNumbers ?? "",
        li?.petShopInvoiceNumber ?? "",
        li?.treatmentInvoiceNumber ?? "",
      ]?.filter(Boolean);
      const reqObj = {
        name: `${invoiceNumbers?.[0]}, ₹${total}, ${moment(new Date(li?.createdDate)).format("DD MMM YYYY")}`,
        value: (li?.paymentId ?? "")?.toString(),
        paymentId: li?.paymentId,
        total,
        advanceAmount: li?.advanceAmount,
      };
      return reqObj;
    });
    const listWithAmount = [
      {
        name: "All",
        value: "All",
        total: 0,
        advanceAmount: hugePayments?.data?.[0]?.advanceAmount ?? 0,
      },
      ...(reqList ?? [])?.filter((li) => li?.total > 0),
    ];
    return listWithAmount;
  };

  const onClickPay = () => {
    let errs = {};
    if (
      !modValues?.amount ||
      isNaN(Number(modValues?.amount)) ||
      Number(modValues?.amount) <= 0 ||
      Number(modValues?.amount) >
        modValues?.invoiceNumber?.reduce((acc, obj) => {
          return acc + (Number(obj?.total ?? 0) ?? 0);
        }, 0) ||
      (modValues?.paymentMode?.value === "advanceAdjustment" &&
        Number(modValues?.amount) >
          Number(getInvoiceList()?.[0]?.advanceAmount ?? 0))
    ) {
      errs = {
        ...errs,
        amount:
          modValues?.paymentMode?.value === "advanceAdjustment" &&
          Number(modValues?.amount) >
            Number(getInvoiceList()?.[0]?.advanceAmount ?? 0)
            ? "Insufficient credit balance"
            : !modValues?.amount
              ? "This field is required"
              : Number(modValues?.amount) >
                  modValues?.invoiceNumber?.reduce((acc, obj) => {
                    return acc + (Number(obj?.total ?? 0) ?? 0);
                  }, 0)
                ? "Amount must be less than or equal to balance due"
                : Number(modValues?.amount) <= 0
                  ? "Amount must be positive"
                  : "",
      };
    }
    if (!modValues?.paymentMode?.value) {
      errs = { ...errs, paymentMode: "This field is required" };
    }
    if (modValues?.invoiceNumber?.length === 0) {
      errs = { ...errs, invoiceNumber: "This field is required" };
    }
    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setModErrors(errs);
    }
    if (
      (modValues?.invoiceNumber ?? [])?.filter((li) => li?.value !== "All")
        ?.length === 0
    ) {
      return;
    }
    const multiplePayments = modValues?.invoiceNumber
      ?.filter((bil) => bil?.value !== "All")
      ?.map((bil) => ({ paymentId: bil?.paymentId }))
      ?.sort((a, b) => a?.paymentId - b?.paymentId);
    dispatch(
      updateMultiplePayment({
        multiplePayments,
        amount: Number(modValues?.amount),
        mode: modValues?.paymentMode?.value,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseCollectPay();
        onApiCall();
      }
    });
  };

  const userListByFilter = () => {
    if (newSaleValues?.searchValue === "") return [];
    const search = newSaleValues?.searchValue?.toLowerCase();
    const reqList = users?.filter(
      (usr) =>
        usr?.name?.toLowerCase().includes(search) ||
        usr?.email?.toLowerCase().includes(search) ||
        usr?.mobile?.toLowerCase().includes(search),
    );
    return reqList;
  };

  const onNewSaleChange = (name, value) => {
    const reqObj = { ...newSaleValues, [name]: value };
    if (name === "searchType") {
      reqObj.searchValue = "";
      reqObj.pet = null;
      reqObj.user = null;
    }
    if (name === "user" || name === "pet") {
      reqObj.error = false;
      reqObj.searchEnabled = false;
      if (name === "user") reqObj.pet = null;
      if (name === "pet") reqObj.user = null;
    }
    if (name === "searchValue") {
      if (value?.length > 2) {
        if (newSaleValues?.searchType === "user") {
          dispatch(
            getClinicUsers(
              `?search=${value}&itemSize=30&page=1&userData=${branchesDataSharing?.petData}`,
            ),
          );
        } else {
          dispatch(
            getClinicPetList({
              type: "all",
              page: 1,
              itemSize: 30,
              petName: value,
              petData: branchesDataSharing?.petData,
            }),
          );
          // dispatch(
          //   getClinicPets(
          //     `?type=all${getPetSearchType(value)}&search=${value}&page=1&itemSize=30&userData=${branchesDataSharing?.petData}`,
          //   ),
          // );
        }
      }
      reqObj.searchEnabled = true;
    }
    setNewSaleValues(reqObj);
  };

  const onCreateNewSale = () => {
    if (!newSaleValues?.user?.id && !newSaleValues?.pet?.petId) {
      return setNewSaleValues({
        ...newSaleValues,
        error: true,
      });
    }
    const reqData = {
      type: newSaleValues?.billAs,
      paymentOption: "draft",
      direct: [],
      discountValue: 0,
      discountType: "percentage",
      referenceNo: "",
    };
    if (newSaleValues?.user?.id) reqData.userId = newSaleValues?.user?.id;
    if (newSaleValues?.pet?.petId) {
      reqData.petId = newSaleValues?.pet?.petId;
      reqData.userId = newSaleValues?.pet?.userId;
    }
    dispatch(addDirectBilling(reqData)).then((res) => {
      if (res?.payload) {
        setNewSaleValues(initSaleValues);
        setSelecetdPayment({
          paymentId: res?.payload?.data,
          type: newSaleValues?.billAs,
        });
        setActiveTab("PointOfSales");
      }
    });
  };

  const reqDraftPayments = () => {
    const reqList = (dashData?.draftPayments ?? [])?.filter(
      (li) =>
        (li?.type === "Pharmacy" || li?.type === "Pet Shop") &&
        (li?.checkOut === "P" || li?.checkOut === "Y" ? false : true) &&
        !li?.invoiceNumbers,
      // li?.paymentOption === "draft" &&
      // (li?.type === "Pharmacy" || li?.type === "Pet Shop") &&
      // Number(li?.balanceDue) > 0 &&
      // li?.status === "unpaid",
    );

    return reqList;
  };

  return (
    <>
      <div className="ph20 scroll-90vh">
        <div className="flex-row-between mv10">
          <div className="w30Per">
            <div className="bil-dash-card bil-card-green">
              <div class="p15">
                <Typography className="fs12 font-bold gray-color">
                  Today's Collection
                </Typography>
                <Typography className="fs30 font-bold black">
                  ₹
                  {dashData?.paidTotalAmount?.toString()?.length > 0
                    ? Number(dashData?.paidTotalAmount)?.toFixed(0)
                    : dashData?.paidTotalAmount}
                </Typography>
                <div className="flex-row-ali-cen">
                  {getPaidPercentage() > 0 ? (
                    <ArrowUpwardIcon sx={w10h10GrayIcon} />
                  ) : (
                    <ArrowDownwardIcon sx={w10h10GrayIcon} />
                  )}
                  <Typography className="fs12 font-medium gray-color ml2">
                    {getPaidPercentage()}% vs yesterday
                  </Typography>
                </div>
                <div className="mv5">
                  <Divider />
                </div>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor mt10"
                  onClick={() => onViewAllTrans("today")}
                >
                  View today's transactions
                </Typography>
              </div>
            </div>
          </div>
          <div className="w30Per">
            <div className="bil-dash-card bil-card-orange">
              <div class="p15">
                <Typography className="fs12 font-bold gray-color">
                  Outstanding Balance
                </Typography>
                <Typography className="fs30 font-bold black">
                  ₹
                  {dashData?.unpaidTotalAmount?.toString()?.length > 0
                    ? Number(dashData?.unpaidTotalAmount)?.toFixed(0)
                    : dashData?.unpaidTotalAmount}
                </Typography>
                <Typography className="fs12 font-medium gray-color">
                  across {dashData?.outstandingBillCount ?? 0} invoices
                </Typography>
                <div className="mv5">
                  <Divider />
                </div>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor mt10"
                  onClick={() => onViewAllTrans("unpaid")}
                >
                  View all unpaid
                </Typography>
              </div>
            </div>
          </div>
          <div className="w30Per">
            <div className="bil-dash-card bil-card-blue">
              <div class="p15">
                <Typography className="fs12 font-bold gray-color">
                  Pending Drafts
                </Typography>
                <Typography className="fs30 font-bold black">
                  {dashData?.draftPaymentsCount}
                </Typography>
                <Typography className="fs12 font-medium gray-color">
                  Incomplete transactions
                </Typography>
                <div className="mv5">
                  <Divider />
                </div>
                {/* <Typography className="blue-color fs12 txt-semi-bold underline cursor mt10">
                  Complete drafts
                </Typography> */}
              </div>
            </div>
          </div>
        </div>

        <div className="mv20 flex-row-ali-cen">
          <div>
            <CustomButton text="New Sale" onClick={onNewSale} smallBtn />
          </div>
          {/* <div className="ml15">
            <CustomButton
              text="Collect Payment"
              onClick={onCollectPay}
              smallBtn
            />
          </div> */}
          <div className="ml15">
            <CustomButton
              text="Finalize Bill"
              onClick={() => setActiveTab("Payments")}
              smallBtn
            />
          </div>
          {/* <div className="ml15">
            <CustomButton text="Process Return" onClick={onReturn} smallBtn />
          </div> */}
        </div>

        <div className="flex-row flex-space-btwn mb30">
          <div className="w48Per">
            <div className="bill-card br5 p15">
              <div className="flex-row-between-align-center">
                <Typography className="fs16 blue-color font-bold">
                  Recent Transactions
                </Typography>
                <Typography
                  className="blue-color fs12 txt-semi-bold cursor underline"
                  onClick={() => onViewAllTrans("all")}
                >
                  View all
                </Typography>
              </div>
              <div className="mv10 scroll-37vh">
                {(dashData?.closedlast5transactions ?? [])?.length > 0 ? (
                  (dashData?.closedlast5transactions ?? [])?.map((li, i) => {
                    const treatRecords = getTreatmentRecordBasedType(
                      li?.paymentDetails,
                      isBillCombined,
                    );
                    const pharRecords = getPharmacyRecordBasedType(
                      li?.paymentDetails,
                      isBillCombined,
                    );
                    const psRecords = getPetShopRecordBasedType(
                      li?.paymentDetails,
                      isBillCombined,
                    );
                    const invoices = [
                      treatRecords?.length > 0
                        ? li?.treatmentInvoiceNumber
                        : "",
                      pharRecords?.length > 0 ? li?.invoiceNumbers : "",
                      psRecords?.length > 0 ? li?.petShopInvoiceNumber : "",
                    ]?.filter(Boolean);
                    return (
                      <div key={`${li?.paymentId}_${i}`}>
                        <div className="flex-row">
                          <div className="w65Per">
                            <Typography className="txt-semi-bold fs14 black">{`${li?.petName?.length > 0 ? `${li?.petName} · ` : ""}${li?.userName}`}</Typography>
                            <Typography className="txt-regular fs12 gray28">{`Invoice #${invoices?.join(", ")} · ${moment(new Date(li?.createdDate)).format("DD MMM YYYY, HH:mm")}`}</Typography>
                          </div>
                          <div className="w35Per flex1-end">
                            <div className="flex-row-ali-cen">
                              <Typography className="txt-semi-bold fs14 black">
                                ₹
                                {Number(
                                  roundWithSignedDiff(
                                    getTaxAndSubTotalAndTotal(
                                      getTreatmentRecordBasedType(
                                        li?.paymentDetails,
                                      ),
                                    )?.subTotal,
                                  )?.rounded +
                                    roundWithSignedDiff(
                                      getTaxAndSubTotalAndTotal(
                                        getPharmacyRecordBasedType(
                                          li?.paymentDetails,
                                        ),
                                      )?.subTotal,
                                    )?.rounded +
                                    roundWithSignedDiff(
                                      getTaxAndSubTotalAndTotal(
                                        getPetShopRecordBasedType(
                                          li?.paymentDetails,
                                        ),
                                      )?.subTotal,
                                    )?.rounded,
                                )?.toFixed(2)}
                              </Typography>
                              <Typography
                                className={`txt-semi-bold fs10 ml10 ph5 pv2 br5 ${
                                  getPaymentStatus(li, isBillCombined) ===
                                  "paid"
                                    ? "green-back4 green4"
                                    : getPaymentStatus(li, isBillCombined)
                                      ? "red4 red-back"
                                      : "card-head-orange-color org-back"
                                }`}
                              >
                                {
                                  paymentStatusEnum?.[
                                    getPaymentStatus(li, isBillCombined)
                                  ]
                                }
                              </Typography>
                            </div>
                          </div>
                        </div>
                        {(dashData?.last5transactions ?? [])?.length !==
                        i + 1 ? (
                          <div className="mv5">
                            <Divider />
                          </div>
                        ) : null}
                      </div>
                    );
                  })
                ) : (
                  <div className="no-rec">No records available</div>
                )}
              </div>
            </div>
          </div>
          {/* <div className="w48Per">
            <div className="bill-card br5 p15">
              <div className="flex-row-between-align-center">
                <Typography className="fs16 blue-color font-bold">
                  Draft Transactions
                </Typography>
              </div>
              <div className="mv10 scroll-37vh">
                {reqDraftPayments()?.length > 0 ? (
                  reqDraftPayments()?.map((li, i) => (
                    <div key={`${li?.paymentId}_${i}`}>
                      <div className="flex-row">
                        <div className="w65Per">
                          <Typography className="txt-semi-bold fs14 black">
                            {li?.userName}
                          </Typography>
                          <Typography className="txt-regular fs12 gray28">
                            {moment(new Date(li?.createdDate)).format(
                              "DD MMM YYYY, HH:mm",
                            )}
                          </Typography>
                        </div>
                        <div className="w35Per flex1-end">
                          <div className="flex-row-ali-cen">
                            <Typography className="txt-semi-bold fs14 black">
                              ₹{" "}
                              {Number(
                                getTaxAndSubTotalAndTotal(
                                  li?.type === "Pharmacy"
                                    ? getPharmacyRecordBasedType(
                                        li?.paymentDetails,
                                      )
                                    : getPetShopRecordBasedType(
                                        li?.paymentDetails,
                                      ),
                                )?.subTotal - Number(li?.amtPaid ?? 0),
                              )?.toFixed(2)}
                            </Typography>                            
                            <div
                              className="cursor ml10"
                              onClick={() => onEditPos(li)}
                            >
                              <div className="flex-center">
                                <EditIcon sx={w20h20BlueIcon} />
                              </div>
                              <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                Edit
                              </Typography>
                            </div>
                            <div
                              className="cursor ml10"
                              onClick={() => onDeletePos(li)}
                            >
                              <div className="flex-center">
                                <DeleteOutlineIcon sx={delBtn} />
                              </div>
                              <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                Delete
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                      {reqDraftPayments()?.length !== i + 1 ? (
                        <div className="mv5">
                          <Divider />
                        </div>
                      ) : null}
                    </div>
                  ))
                ) : (
                  <div className="no-rec">No records available</div>
                )}
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <PaymentReturn
        returnModVisible={retModVsble}
        onReturnModClose={onCloseReturn}
        headerName="Stock Adjustment"
      />

      <CustomModal
        open={newSaleValues?.visible}
        onClose={onCloseNewSaleMod}
        header="New Sale"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-85vh ph20">
          {!isBillCombined ? (
            <>
              <div className="font-medium fs14 black2">Bill as</div>
              <CustomSelect
                list={billAsForBillingHistory}
                value={newSaleValues?.billAs}
                handleChange={(e) =>
                  onNewSaleChange("billAs", e?.target?.value)
                }
                select
                // search
              />
            </>
          ) : null}
          <div className="font-medium fs14 black2 mt10">Search Type</div>
          <CustomSelect
            list={[
              { name: "User", value: "user" },
              { name: "Pet", value: "pet" },
            ]}
            value={newSaleValues?.searchType}
            handleChange={(e) =>
              onNewSaleChange("searchType", e?.target?.value)
            }
            select
            // search
          />
          <div className="mt15" />
          <CustomTextField
            name="searchValue"
            fullWidth
            handleChange={(e) =>
              onNewSaleChange("searchValue", e?.target?.value)
            }
            value={newSaleValues?.searchValue}
            placeholder={`Search ${newSaleValues?.searchType === "user" ? "Customer" : "Pet"} here...`}
            error={newSaleValues?.error}
            helperText={
              newSaleValues?.error
                ? `Please Select ${newSaleValues?.searchType === "user" ? "Customer" : "Pet"}`
                : ""
            }
          />
          {newSaleValues?.searchValue?.length > 0 &&
            newSaleValues?.searchEnabled &&
            newSaleValues?.searchType === "user" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {userListByFilter()?.length > 0 &&
                  userListByFilter()?.map((usr) => {
                    return (
                      <div
                        className="flex-row-ali-cen cursor mv10 cus-box"
                        key={usr?.id}
                        onClick={() => onNewSaleChange("user", usr)}
                      >
                        <div className="w15Per">
                          <div className="flex-center">
                            <img
                              src={require("../../../assets/images/png/contact.png")}
                              className="imghw40"
                            />
                          </div>
                        </div>
                        <div className="w75Per">
                          <div className="flex-coloum ml10">
                            <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                              Parent Name:
                              <Typography className="txt-regular fs12 black15 ml5">
                                {usr?.name}
                              </Typography>
                            </Typography>
                            <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                              Phone:
                              <Typography className="txt-regular fs12 black15 ml5">
                                {usr?.mobile}
                              </Typography>
                            </Typography>
                            <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                              Email:
                              <Typography className="txt-regular fs12 black15 ml5">
                                {usr?.email}
                              </Typography>
                            </Typography>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </Grid>
            )}
          {newSaleValues?.searchValue?.length > 0 &&
            newSaleValues?.searchEnabled &&
            newSaleValues?.searchType === "pet" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {(clinicPetList?.pets ?? [])?.length > 0 &&
                  (clinicPetList?.pets ?? [])?.map((petDat) => {
                    const pet = petDat?.listOfDatas;
                    return (
                      <div
                        className="flex-row-ali-cen cursor mv10 cus-box"
                        key={pet?.petId}
                        onClick={() => onNewSaleChange("pet", pet)}
                      >
                        <div className="w15Per">
                          <div className="flex-center">
                            <img
                              src={require("../../../assets/images/png/contact.png")}
                              className="imghw40"
                            />
                          </div>
                        </div>
                        <div className="w75Per">
                          <div className="flex-coloum ml10">
                            <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                              Pet Name:
                              <Typography className="txt-regular fs12 black15 ml5">
                                {pet?.petName}
                              </Typography>
                            </Typography>
                            <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                              Parent Name:
                              <Typography className="txt-regular fs12 black15 ml5">
                                {pet?.userName}
                              </Typography>
                            </Typography>
                            <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                              Breed:
                              <Typography className="txt-regular fs12 black15 ml5">
                                {pet?.breed}
                              </Typography>
                            </Typography>
                            <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                              DOB:
                              <Typography className="txt-regular fs12 black15 ml5">
                                {moment(new Date(pet?.dob)).format(
                                  "DD MMM YYYY",
                                )}
                              </Typography>
                            </Typography>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </Grid>
            )}

          {(
            !newSaleValues?.searchEnabled &&
            (newSaleValues?.pet?.petId || newSaleValues?.user?.id)
              ? true
              : false
          ) ? (
            <div className="flex-row-ali-cen cursor mv10 cus-box">
              <div className="w15Per">
                <div className="flex-center">
                  <img
                    src={require("../../../assets/images/png/contact.png")}
                    className="imghw40"
                  />
                </div>
              </div>
              <div className="w75Per">
                <div className="flex-coloum ml10">
                  {newSaleValues?.pet?.petId ? (
                    <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                      Pet Name:
                      <Typography className="txt-regular fs12 black15 ml5">
                        {newSaleValues?.pet?.petName}
                      </Typography>
                    </Typography>
                  ) : null}
                  <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                    Parent Name:
                    <Typography className="txt-regular fs12 black15 ml5">
                      {newSaleValues?.user?.name ??
                        newSaleValues?.pet?.userName}
                    </Typography>
                  </Typography>
                  {newSaleValues?.user?.id ? (
                    <>
                      <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                        Phone:
                        <Typography className="txt-regular fs12 black15 ml5">
                          {newSaleValues?.user?.mobile}
                        </Typography>
                      </Typography>
                      <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                        Email:
                        <Typography className="txt-regular fs12 black15 ml5">
                          {newSaleValues?.user?.email}
                        </Typography>
                      </Typography>
                    </>
                  ) : null}
                  {newSaleValues?.pet?.petId ? (
                    <>
                      <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                        Breed:
                        <Typography className="txt-regular fs12 black15 ml5">
                          {newSaleValues?.pet?.breed}
                        </Typography>
                      </Typography>
                      <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                        DOB:
                        <Typography className="txt-regular fs12 black15 ml5">
                          {moment(new Date(newSaleValues?.pet?.dob)).format(
                            "DD MMM YYYY",
                          )}
                        </Typography>
                      </Typography>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
          <div className="flex1-end mt20">
            <div>
              <CustomButton smallBtn text="Submit" onClick={onCreateNewSale} />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure want to delete the payment?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={onCloseDelMod} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={onConfirmDelete}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={collectPayModVsble}
        onClose={onCloseCollectPay}
        header="Collect Payment"
        modalWidth={30}
        rightModal
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Type <span className="red-color">*</span>
              </div>
              <CustomSelect
                list={[{ name: "Sales", value: "Sales" }]}
                value={{ name: "Sales", value: "Sales" }}
                search
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                fullWidth
                search
                value={modValues?.searchValue}
                placeholder="Search Customer"
                handleChange={(e) =>
                  onChangeModValue("searchValue", e?.target?.value)
                }
                backgroundColor={AppColors.gray6}
              />
            </Grid>
            {modValues?.searchValue?.length > 0 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {getFilteredUserList()?.length > 0 &&
                  getFilteredUserList()?.map((usr) => {
                    return (
                      <Grid
                        container
                        spacing={1}
                        key={usr?.id}
                        className="cursor"
                        onClick={() => handleSelectedUser(usr)}
                      >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Card
                                sx={{
                                  borderRadius: 1,
                                  padding: 2,
                                  borderTopColor: AppColors.appPrimary,
                                }}
                                className="CustomCard-back-appointment"
                              >
                                <div className="maint">
                                  <div className="flex-row">
                                    <Grid item>
                                      <div className="flex-row">
                                        <div className="flex-start">
                                          <div className="flex-column">
                                            <div className="flex-row">
                                              <Typography className="mb10 font-bold fs14 capitalize">
                                                {usr?.name}
                                              </Typography>
                                            </div>
                                            <Typography className="mb10 txt-regular card-gray-color fs12">
                                              {usr?.email}
                                            </Typography>
                                            <Typography className="mb10 txt-regular card-gray-color fs12">
                                              {usr?.mobile}
                                            </Typography>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                  </div>
                                </div>
                              </Card>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Customer
                <span className="red-color">*</span>
              </div>
              <CustomSelect
                list={[]}
                value={modValues?.customer}
                helperText={modErrors?.customer}
                error={!!modErrors?.customer}
                search
                disabled
              />
            </Grid>
            {modValues?.customer?.value ? (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Invoice Number <span className="red-color">*</span>
                  </div>
                  <CustomSelect
                    list={getInvoiceList()}
                    name="invoiceNumber"
                    handleChange={(e) => {
                      onChangeModValue("invoiceNumber", e?.target?.value);
                    }}
                    value={modValues?.invoiceNumber}
                    helperText={modErrors?.invoiceNumber}
                    error={!!modErrors?.invoiceNumber}
                    multiSelectSearchCheck
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mh20"
                >
                  <div className="bil-bal-con">
                    <div className="flex-row">
                      <div>
                        <Typography className="font-bold fs14 red-color">
                          Balance Due
                        </Typography>
                      </div>
                      <div className="flex1-end">
                        <Typography className="font-bold fs14 red-color">
                          Rs{" "}
                          {Number(
                            modValues?.invoiceNumber?.reduce((acc, obj) => {
                              return acc + (Number(obj?.total ?? 0) ?? 0);
                            }, 0),
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="mt10"
                >
                  <CustomTextField
                    label="Amount"
                    name="amount"
                    fullWidth
                    handleChange={(e) =>
                      onChangeModValue("amount", e?.target?.value)
                    }
                    value={modValues?.amount}
                    labelTop
                    helperText={modErrors?.amount}
                    error={!!modErrors?.amount}
                    type="number"
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mt10">
                  <div className="font-medium fs14 black2">Payment Mode</div>
                  <PaymentModeDropdown
                    list={[]}
                    value={modValues?.paymentMode}
                    error={!!modErrors?.paymentMode}
                    helperText={modErrors?.paymentMode}
                    onChange={(e, value) => {
                      onChangeModValue("paymentMode", e);
                    }}
                    name="paymentMode"
                    label=""
                  />
                </Grid>
                {modValues?.paymentMode?.value === "advanceAdjustment" ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="txt-semi-bold fs14 orange5">
                      Available Balance:{" "}
                      {(
                        modValues?.invoiceNumber?.[0]?.advanceAmount ?? ""
                      )?.toString()?.length > 0
                        ? Number(
                            modValues?.invoiceNumber?.[0]?.advanceAmount,
                          )?.toFixed(2)
                        : "-"}
                    </Typography>
                  </Grid>
                ) : null}

                <div className="flex1-end mt20">
                  <div>
                    <CustomButton smallBtn text="Pay" onClick={onClickPay} />
                  </div>
                </div>
              </>
            ) : null}
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default PaymentDashboard;
